import React, {useEffect, useState} from 'react';
import { NavLink as RouterLink } from "react-router-dom";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import {normalizeRoute, restorePath} from "ultra/helpers/route";
import {getClientDefaultImageUrl} from 'ultra/configs/general';
import {getClientUrl} from 'ultra/configs/general';

import './index.scss';

export default function Banner(props) {
    const {data} = props;

    // const [link, setLink] = useState();
    const [target, setTarget] = useState();

    const {external, photo, city, text_first_line, text_second_line, logo, pic, uri, url, button, align, title, label, background, backgroundLeft, backgroundRight} = data;

    useEffect(() => {
        // if (uri) {
        //     setLink(getClientUrl(city, restorePath(normalizeRoute(uri))))
        // }
        // else if (url) {
        //     setLink(url)
        // }

        setTarget(external ? '_blank' : '_self')
    }, [])

    if (!data) return <></>;

    const renderImage = () => {
        if (text_first_line && text_second_line) {
            return <div className='BannerImgWrap'>
                <div className={`BannerConstructor ${photo ? "hasBackground" : ""}`} style={background ? {
                    backgroundImage: photo ? `url(${getClientDefaultImageUrl(window, photo)})` : background,
                    color: "#ffffff"
                } : {}}>
                    {logo && <img src={getClientDefaultImageUrl(window, logo)} className='logo'/>}
                    <div className='text'>
                        <div className="text_first_line" style={background ? {
                            color: "#ffffff"
                        } : {}}>{text_first_line}</div>
                        <div className="text_second_line" style={background ? {
                            color: "#ffffff",
                            opacity: ".8"
                        } : {}}>{text_second_line}</div>
                    </div>
                    {pic && <img src={pic} className='pic' />}
                    <KeyboardArrowRightIcon />
                </div>
            </div>
        }

        return <div className='BannerImgWrap'>
            {(url && external) && <span className='external'>
                <ArrowOutwardIcon />
            </span>}
            {label && <div className='BannerLabel'>{label}</div>}
            <span className={align === 'right' ? 'image right' : 'image'} style={{
                backgroundImage: `url(${getClientDefaultImageUrl(window, photo)})`,
                backgroundColor: background,
            }}></span>
            {backgroundLeft && <span className='backgroundLeft' style={{backgroundColor: backgroundLeft}}></span>}
            {backgroundRight && <span className='backgroundRight' style={{backgroundColor: backgroundRight}}></span>}
        </div>
    }

    if (button && title) return <div className='Banner BannerWithButton'>
        {renderImage()}
        
        {url ?
            <a href={url} className='BannerButton' target={target}>{title}</a>
            : <RouterLink  className='BannerButton' to={restorePath(uri)} target={target}>{title}</RouterLink>
        }
    </div>

    if (!button && title) return <div className='Banner'>
        {url ?
            <a href={url} target={target}>
                {renderImage()}
                <span className='BannerText'>{title}</span>
            </a>
            :
            <RouterLink to={restorePath(uri)} target={target}>
                {renderImage()}
                <span className='BannerText'>{title}</span>
            </RouterLink>
        }
    </div>

    const className = props.className ? 'Banner ' + props.className : 'Banner'

    return <div className={className}>
        {url ?
            <a href={url} target={target}>
                {renderImage()}
            </a>
            :
            <RouterLink to={restorePath(uri)}>
                {renderImage()}
            </RouterLink>
        }
    </div>
}